import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class GlobalService {

  constructor( private http:HttpClient ) {

  }

  public navigate(url:string){
    return this.http.get(url ).map( res => {
        return res;
    });
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/services/global.service.ts